const inventoryManagementConstantsAr = {
  inventoryManagementMediaId: 'رقم الفيديو',
  inventoryManagementThumbnail: 'الصورة',
  inventoryManagementTitleHeader: 'إدارة الوسائط المتعددة',
  inventoryManagementTitle: 'العنوان',
  inventoryManagementDate: 'تاريخ التحديث',
  inventoryManagementEdit: 'تعديل',
  InventoryManagementToolTip: 'إدارة الوسائط المتعددة',
  inventoryManagementEditButton: 'تعديل',
  inventoryManagementErrorSnackBar: '! حدث خطأ ما',
  inventoryManagementDeleted:' المحذوفات ',
  totalInventoryItems: 'العناصر الموجودة في المخزون',
  totalVideos: 'الفيديوهات',
  inventoryVideoType: 'فيديو',
  inventoryAudioType: 'صوتي',
  inventoryFileType: 'نوع الملف',
  inventoryLoadMoreButton: 'تحميل المزيد...',
  publishedIconTitle: 'منشور',
  publishedFilterTitle: 'حالة النشر',
  publishedFilter:'منشور',
  unpublishedFilter:'غير منشور',
};

export default inventoryManagementConstantsAr;
